<template>
  <div class="sidebar">
    <v-list class="d-md-none">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <img src='/img/base/avatar.png' >
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{ user ? user.name : '' }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-divider class="m-0 d-md-none"></v-divider>

    <template v-if="user">
      <v-list dense class="mt-2 pt-0">
        <v-list-tile
          v-for="item in items"
          :key="item.title"
          :to="{ name: item.name }"
          active-class="v-list__tile--highlighted"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-divider class="m-0"></v-divider>

      <v-list dense>
        <v-list-tile
          :to="{ name: 'users' }"
          active-class="v-list__tile--highlighted"
          v-if="user.role === 2"
        >
          <v-list-tile-action>
            <v-icon>supervisor_account</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Users</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          :to="{ name: 'profile' }"
          active-class="v-list__tile--highlighted"
        >
          <v-list-tile-action>
            <v-icon>account_circle</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Profile</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-list dense class="btn-logout d-md-none">
        <v-list-tile @click.prevent="logout">
          <v-list-tile-action>
            <v-icon>logout</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {

    data: () => ({
      items: [
        { name: 'sold-out-products', img: 'inbox.png', title: 'Sold Out Products', icon: 'dashboard' },
        { name: 'black-piercers', img: 'inbox.png', title: 'Black Piercers', icon: 'widgets' },
        { name: 'digital-downloads', img: 'inbox.png', title: 'Digital Downloads', icon: 'file_download' },
        { name: 'ear-curations', img: 'inbox.png', title: 'Ear Curations', icon: 'storage' },
        { name: 'surveys', img: 'inbox.png', title: 'Survey', icon: 'equalizer' },
      ]
    }),

    computed: mapGetters({
      user: 'auth/user'
    }),

    methods: {
      async logout () {
        // Log out the user.
        await this.$store.dispatch('auth/logout')

        // Redirect to login.
        this.$router.push({ name: 'login' })
      }
    }
  }
</script>

<style>
  .theme--light.v-list .v-list__tile--link,
  .theme--light.v-list .v-list__tile--link:hover,
  .md-theme-default a:not(.md-button) {
    color: rgba(0,0,0,.87);
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/Sidebar.vue